import React from "react";
import Image from "react-bootstrap/Image";

export const ExperienceTableHead = (props) => {
    return (
        <tr>
            <td
                className="total-pax " style={{ width: "2%" }}
            >
            </td>
            <td
                className="total-pax " style={{ width: "15%" }}
            >
                <p className="font_16_r">
                    Name /<br />
                    Request Number
                </p>
            </td>
            <td className={"location "} style={{ width: "15%" }}>
                <p className="font_16_r">Total PAX</p>
            </td>
            <td
                style={{ width: "20%" }}
                className="d-flex align-items-center justify-content-center "
            >
                <div>
                    <p className="font_16_r">Date / Time</p>
                    <p className="font_16_r">Timer</p>
                    <p className="font_10_r">(DD:HH:MM:SS)</p>
                </div>
                <div
                    className="ml-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => (props?.sortByDateTime ? props.sortByDateTime() : {})}
                >
                    <Image
                        alt="Sort"
                        title="Sort"
                        width="20px"
                        src={require("../../../../assets/images/iconButton/ntimer.png")}
                    />
                </div>
            </td>

            <td className="seating-preference text-center" style={{ width: "15%" }}>
                <p className="font_16_r">
                    Payment
                    <br />
                    Status
                </p>
            </td>
            <td className="seating-preference align-items-center text-center " style={{ width: "15%" }}>
                <p className="font_16_r ml-4">
                    Experience
                    <br />
                    Name/ID
                </p>
            </td>
            <td className="action pl-4 text-center" style={{ width: "20%" }}>
                <p className="font_16_r">Actions<br /> Total Wait Time</p>
            </td>
        </tr>
    );
};

// export const SeatingDashboardTableManagement = () => {
//     return (
//         <React.Fragment>
//             <thead className="sd_table_thead">
//                 <tr>
//                     <th>
//                         <p className="font_16_m">Table Management</p>
//                     </th>
//                     <th>
//                         <AddTable />
//                     </th>
//                 </tr>
//             </thead>
//         </React.Fragment>
//     );
// };
